import m from "react";
import { FlexContainer as S, elMb5 as _ } from "@reapit/elements";
var P = { exports: {} }, y = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T = m, E = Symbol.for("react.element"), I = Symbol.for("react.fragment"), B = Object.prototype.hasOwnProperty, N = T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, M = { key: !0, ref: !0, __self: !0, __source: !0 };
function j(e, t, r) {
  var n, i = {}, a = null, d = null;
  r !== void 0 && (a = "" + r), t.key !== void 0 && (a = "" + t.key), t.ref !== void 0 && (d = t.ref);
  for (n in t) B.call(t, n) && !M.hasOwnProperty(n) && (i[n] = t[n]);
  if (e && e.defaultProps) for (n in t = e.defaultProps, t) i[n] === void 0 && (i[n] = t[n]);
  return { $$typeof: E, type: e, key: a, ref: d, props: i, _owner: N.current };
}
y.Fragment = I;
y.jsx = j;
y.jsxs = j;
P.exports = y;
var o = P.exports, W = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, n = [];
  t.forEach((a) => {
    (a ? a.split(" ") : []).forEach((s) => {
      if (s.startsWith("atm_")) {
        const [, f] = s.split("_");
        r[f] = s;
      } else
        n.push(s);
    });
  });
  const i = [];
  for (const a in r)
    Object.prototype.hasOwnProperty.call(r, a) && i.push(r[a]);
  return i.push(...n), i.join(" ");
}, h = W;
function F(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var H = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, v = /* @__PURE__ */ F(
  function(e) {
    return H.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), U = (e) => e.toUpperCase() === e, z = (e) => (t) => e.indexOf(t) === -1, A = (e, t) => {
  const r = {};
  return Object.keys(e).filter(z(t)).forEach((n) => {
    r[n] = e[n];
  }), r;
};
function D(e, t, r) {
  const n = A(t, r);
  if (!e) {
    const i = typeof v == "function" ? { default: v } : v;
    Object.keys(n).forEach((a) => {
      i.default(a) || delete n[a];
    });
  }
  return n;
}
var q = (e, t) => {
};
function V(e) {
  let t = "";
  return (r) => {
    const n = (a, d) => {
      const { as: s = e, class: f = t } = a, O = r.propsAsIs === void 0 ? !(typeof s == "string" && s.indexOf("-") === -1 && !U(s[0])) : r.propsAsIs, l = D(O, a, [
        "as",
        "class"
      ]);
      l.ref = d, l.className = r.atomic ? h(r.class, l.className || f) : h(l.className || f, r.class);
      const { vars: g } = r;
      if (g) {
        const x = {};
        for (const u in g) {
          const C = g[u], k = C[0], L = C[1] || "", R = typeof k == "function" ? k(a) : k;
          q(R, r.name), x[`--${u}`] = `${R}${L}`;
        }
        const b = l.style || {}, w = Object.keys(b);
        w.length > 0 && w.forEach((u) => {
          x[u] = b[u];
        }), l.style = x;
      }
      return e.__wyw_meta && e !== s ? (l.as = s, m.createElement(e, l)) : m.createElement(s, l);
    }, i = m.forwardRef ? m.forwardRef(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (a) => {
        const d = A(a, ["innerRef"]);
        return n(d, a.innerRef);
      }
    );
    return i.displayName = r.name, i.__wyw_meta = {
      className: r.class || t,
      extends: e
    }, i;
  };
}
var X = V;
const Y = () => S, $ = /* @__PURE__ */ X(Y())({
  name: "StyledCard",
  class: "s1uc8792",
  propsAsIs: !0
}), K = ({
  className: e,
  ...t
}) => /* @__PURE__ */ o.jsx(S, {
  isFlexColumn: !0,
  className: h("w1yaav9t", e),
  ...t
}), G = (e) => /* @__PURE__ */ o.jsx(S, {
  isFlexColumn: !0,
  ...e
}), p = (e) => /* @__PURE__ */ o.jsx($, {
  isFlexColumn: !0,
  ...e
});
p.LoaderBodyWrapper = K;
p.LoaderBodySectionWrapper = G;
const c = ({
  variant: e = "rectangle",
  width: t = "100%",
  height: r = "1rem",
  className: n
}) => /* @__PURE__ */ o.jsx("div", {
  className: h("sbi06ha", e, n),
  style: {
    width: t,
    height: r
  }
}), Q = (e) => e.isShow ? /* @__PURE__ */ o.jsxs(p, { role: "progressbar", children: [
  /* @__PURE__ */ o.jsx(c, { className: _, height: "1.5rem" }),
  /* @__PURE__ */ o.jsxs(p.LoaderBodyWrapper, { children: [
    /* @__PURE__ */ o.jsxs(p.LoaderBodySectionWrapper, { style: { gap: "0.25rem" }, children: [
      /* @__PURE__ */ o.jsx(c, { height: "1.25rem" }),
      /* @__PURE__ */ o.jsx(c, { height: "1.25rem", width: "75%" })
    ] }),
    /* @__PURE__ */ o.jsxs(p.LoaderBodySectionWrapper, { style: { gap: "0.25rem" }, children: [
      /* @__PURE__ */ o.jsx(c, {}),
      /* @__PURE__ */ o.jsx(c, {}),
      /* @__PURE__ */ o.jsx(c, { width: "75%" })
    ] }),
    /* @__PURE__ */ o.jsxs(p.LoaderBodySectionWrapper, { style: { gap: "0.25rem" }, children: [
      /* @__PURE__ */ o.jsx(c, {}),
      /* @__PURE__ */ o.jsx(c, { width: "75%" })
    ] })
  ] })
] }) : null;
export {
  p as LoaderBox,
  Q as LoaderCards,
  c as LoadingSkeleton
};
